import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import BookingTypeEnum from '@app/models-internal/booking-type.enum';

@Component({
    selector: "booking-type-icon",
    templateUrl: "./booking-type-icon.component.html",
    styleUrls: ["./booking-type-icon.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class BookingTypeIconComponent implements OnInit {
  private readonly _componentName = 'BookingTypeIconComponent';

  private _bookingTypeId: number;
  iconUrl: string;
  public get bookingTypeId(): number {
    return this._bookingTypeId;
  }

  @Input()
  public set bookingTypeId(v: number) {
    this._bookingTypeId = v;

    var t = v as BookingTypeEnum;

    switch (t) {
      case BookingTypeEnum.Daily:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/green-energy.svg';
        break;

      case BookingTypeEnum.Hipcamp:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/hipcamp-logo-32x32.png';
        break;

      case BookingTypeEnum.Scout:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/hiking-flag.svg';
        break;

      case BookingTypeEnum.Seasonal:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/chili.svg';
        break;

      case BookingTypeEnum.Permit:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/ticket.svg';
        break;

            

      default:
        this.iconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/icons/medal.svg';

        break;
    }
  }

  constructor() {}

  ngOnInit() {}
}
